import { styled } from '@mui/material';

export const Section = styled('div')(({ theme }) => ({
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  overflow: 'hidden',
}));
